module.exports = __webpack_public_path__ + "static/media/analytics.afb2ce58.svg";